import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Kingdoms from "./pages/Kingdoms";
import KingdomDetail from "./pages/KingdomDetail";
import Timeline from "./pages/Timeline";
import Dispersion from "./pages/Dispersion";
import Lessons from "./pages/Lessons";
import LessonDetail from "./pages/LessonDetail";
import Worksheet from "./pages/Worksheet";
import Quizzes from "./pages/Quizzes";
import QuizDetail from "./pages/QuizDetail";
import Tutor from "./pages/Tutor";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Resources from "./pages/Resources";
import AdminFiles from "./pages/AdminFiles";
import Search from "./pages/Search";
import GlobePage from "./pages/Globe";
import Stories from "./pages/Stories";
import StoryDetail from "./pages/StoryDetail";
import LearnerProfile from "./pages/LearnerProfile";
import Assignments from "./pages/Assignments";
import AssignmentDetail from "./pages/AssignmentDetail";
import Premium from "./pages/Premium";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import { PremiumGate } from "./components/Premium";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/kingdoms" element={<Kingdoms />} />
        <Route path="/kingdoms/:slug" element={<KingdomDetail />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/dispersion" element={<Dispersion />} />
        <Route path="/lessons" element={<Lessons />} />
        <Route path="/lessons/:slug" element={<LessonDetail />} />
        <Route path="/lessons/:slug/worksheet" element={<PremiumGate><Worksheet /></PremiumGate>} />
        <Route path="/quizzes" element={<PremiumGate><Quizzes /></PremiumGate>} />
        <Route path="/quizzes/:slug" element={<PremiumGate><QuizDetail /></PremiumGate>} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/search" element={<Search />} />
        <Route path="/globe" element={<GlobePage />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/stories/:storyId" element={<StoryDetail />} />
        <Route path="/learners/:learnerId" element={<LearnerProfile />} />
        <Route path="/assignments" element={<PremiumGate><Assignments /></PremiumGate>} />
        <Route path="/assignments/:slug" element={<AssignmentDetail />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminFiles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tutor"
          element={
            <ProtectedRoute>
              <PremiumGate>
                <Tutor />
              </PremiumGate>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: { background: "#1F1D1C", border: "1px solid #2A2624", color: "#F4F1EA" },
          }}
        />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
